import { useEffect } from "react";

export default function useDynamicFavicon() {
    useEffect(() => {
        const setFaviconLinks = (isDark) => {
            [
                "icon",
                "apple-touch-icon",
                "shortcut icon"
            ].forEach((rel) => {
                const links = document.querySelectorAll(`link[rel="${rel}"]`);
                links.forEach((link) => link.parentNode.removeChild(link));
            });

            const favicon = document.createElement("link");
            favicon.rel = "icon";
            favicon.type = "image/png";
            favicon.href = process.env.PUBLIC_URL + "/" + (isDark ? "faviconWhite.png" : "faviconBlack.png");
            document.head.appendChild(favicon);
            const appleIcon = document.createElement("link");
            appleIcon.rel = "apple-touch-icon";
            appleIcon.sizes = "180x180";
            appleIcon.href = process.env.PUBLIC_URL + "/" + (isDark ? "faviconWhite.png" : "faviconBlack.png");
            document.head.appendChild(appleIcon);
        };

        const updateFavicons = () => {
            const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
            setFaviconLinks(isDark);
        };

        updateFavicons();
        const media = window.matchMedia("(prefers-color-scheme: dark)");
        media.addEventListener("change", updateFavicons);

        return () => {
            media.removeEventListener("change", updateFavicons);
        };
    }, []);
}

